import { TypographyStyles } from "@faire/web/ui/Typography";
import styled from "styled-components";

export const Title = styled.h2<{ white?: boolean }>`
  ${TypographyStyles({
    h2: true,
    serif: true,
    weight: "book",
  })};
  line-height: 36px;
  letter-spacing: 1px;
  color: #000000;
  margin: 0;
`;
